<script>
import { mapActions } from 'vuex';
import Catalogue from '@/services/catalogue';
import request from '@/services/request';

export default {
    name: "ModalProgramGroupUsers",

    data() {
        return {
            errors: {},

            catalogue: new Catalogue(),

            form: {
                group_id: "",
                user_id: "",
                amount: 0,
                percentage: 0,
            },
            users: [],
            companies: [],
            assigned_users_group: [],
            assigned_users_program: [],
            available_users: [],
        };
    },

    methods: {

        /** Cerrar modal */
        closeModal() {
            this.errors = {};
            this.form = {
                group_id: "",
                user_id: "",
            };
            this.$modal.hide("modalProgramGroupUsers");
        },

       filterAvailable() {
        const all = this.users ?? [];
        const assigned = (this.assigned_users_program ?? []).flat(Infinity).map(String);

        this.available_users = all.filter(u => {
            const key = `${u.user_id}|${u.company_id}`;

            console.log('key:', key, 'assigned:', assigned.includes(key));

            return !assigned.includes(key);
        });
        },

        async saveUser() {

            let parts = this.form.user_id.split('|');

            let payload = {
                program_group_id: this.form.group_id,
                user_id: parts[0],
                company_id: parts[1],
                amount: this.form.amount,
                percentage: this.form.percentage,
            };

            try {
                let { data } = await request.post("/program_group_users", payload);

                this.successNotification(data.message);

                this.closeModal();

                Event.$emit("event-reload-program-relations");

            } catch (error) {
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success"
        }),

    },

    created() {

        Event.$on("event-open-program-group-users", async (data) => {

            this.errors = {};

            this.form.group_id = data.group_id;

            this.assigned_users_program = data.assigned_users_program ?? [];

            let companyIds = data.companies ?? [];

            await this.catalogue.getUsersCompanies(companyIds);
            this.users = this.catalogue.users_companies.map(user => ({
                user_id: user.user_id,
                name: user.name + ' ' + user.last_name,
                company_id: user.company_id,
                company_name: user.company_name,
                amount: 0,
                selected: false,
                percentage: user.percentage,
            }));

            await this.filterAvailable();

            this.$modal.show("modalProgramGroupUsers");
        });
    }
};
</script>

<template>
    <modal name="modalProgramGroupUsers" :width="'50%'" :height="'auto'" :click-to-close="false">

        <form @submit.prevent="saveUser">

            <!-- Cerrar -->
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">Agregar Inversionista al Grupo</h5>
            </div>

            <div class="modal-body">

                <div class="row">

                    <!-- SELECT USUARIO -->
                    <div class="col-md-12 mb-3">
                        <label>Seleccione un Inversionista</label>

                        <select class="form-control" v-model="form.user_id">
                            <option value="">Seleccione</option>

                            <option v-for="u in available_users" :key="u.id" :value="u.user_id + '|' + u.company_id">
                                {{ u.name }} {{ u.last_name }} - {{ u.company_name }}
                            </option>
                        </select>

                        <div class="text-danger" v-if="errors.user_id">
                            {{ errors.user_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mb-3">
                        <label>Monto</label>
                        <money class="form-control" v-model="form.amount"></money>

                        <div class="text-danger" v-if="errors.amount">
                            {{ errors.amount[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mb-3">
                        <label>Porcentaje</label>
                        <money class="form-control" v-model="form.percentage"></money>

                        <div class="text-danger" v-if="errors.percentage">
                            {{ errors.percentage[0] }}
                        </div>
                    </div>

                    <!-- BOTONES -->
                    <div class="col-12 mt-4">
                        <hr>

                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>

                        <button type="button" class="btn float-left btn-outline-warning" @click="closeModal">
                            <i class="fas fa-undo-alt"></i> Cancelar
                        </button>

                    </div>

                </div>

            </div>

        </form>

    </modal>
</template>

<style scoped>
.text-danger {
    font-size: 12px;
}
</style>
